import React from 'react';
import DefaultPopup from '@stelecom/ui-react/components/popups/defaultPopup';
import { PopupButton, PopupContent, PopupText, PopupTitle } from './styled';

const PopupNoWork = (props) => {
    const { isOpen, onClose } = props;

    return (
        <DefaultPopup isOpen={isOpen} onClose={onClose}>
            <PopupContent>
                <PopupTitle>Данная функция временно недоступна.</PopupTitle>
                <PopupText>Приносим извинения за неудобства.</PopupText>
                <PopupButton
                    type='primary'
                    text='Закрыть'
                    onClick={onClose}
                />
            </PopupContent>
        </DefaultPopup>
    );
};

export default PopupNoWork;
